import { render, staticRenderFns } from "./class-student.vue?vue&type=template&id=217e1b1c&scoped=true"
import script from "./class-student.vue?vue&type=script&lang=js"
export * from "./class-student.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217e1b1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('217e1b1c')) {
      api.createRecord('217e1b1c', component.options)
    } else {
      api.reload('217e1b1c', component.options)
    }
    module.hot.accept("./class-student.vue?vue&type=template&id=217e1b1c&scoped=true", function () {
      api.rerender('217e1b1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/senate/detail-pane/class-student.vue"
export default component.exports